import { atom } from 'recoil';

export const isClientModalOpen = atom<boolean>({
  key: 'client.isModalOpen',
  default: false,
});
